import { getToken } from '../../../auth/authenticator';
import { AuthState } from '../../../common/AuthContext.types';
import axiosClient from '../../axios-api';
import DEVELOPMENT_FLAGS from '../../../developmentFlags';

export interface AccountGroupItem {
    id: number;
    name: string;
}

export interface AccountFiltersOptions {
    institutions: string[];
    productTypes: string[];
    accountGroups: AccountGroupItem[];
}

export async function getFilters(
    authState: AuthState
): Promise<AccountFiltersOptions | null> {
    if (DEVELOPMENT_FLAGS.isMock === 'true') {
        return {
            institutions: ['Bank A'],
            productTypes: ['Checking'],
            accountGroups: [{ id: 1, name: 'All Accounts' }]
        };
    }

    let finalResponse: AccountFiltersOptions | null = null;
    const apiUrl = `/accounts/filters?c_id=${authState.clientId}`;

    await axiosClient({
        url: apiUrl,
        method: 'GET',
        headers: {
            Authorization: `Bearer ${await getToken()}`
        }
    })
        .then((response) => {
            finalResponse = response.data;
        })
        .catch((error) =>
            console.log('An error has occured when fetching filters - ', error?.message)
        );

    return finalResponse;
}
